import Component from './Component';

function CreateProposalSuccess(props) {

    return <Component {...props} />;
}

export default CreateProposalSuccess;
